import { createSignal } from 'solid-js'

type AccountState = {
   heightInput: string
   targetWeightInput: string
   targetRunEffortInput: string
   statusMessage: string
   userId: string
   showKeyActions: boolean
   showCreateQr: boolean
   hasDataToDelete: boolean
   downloadStatusMessage: string
   isDownloading: boolean
}

const [accountState, setAccountState] = createSignal<AccountState>({
   heightInput: '',
   targetWeightInput: '',
   targetRunEffortInput: '',
   statusMessage: '',
   userId: '',
   showKeyActions: true,
   showCreateQr: false,
   hasDataToDelete: false,
   downloadStatusMessage: '',
   isDownloading: false,
})

/**
 * Merges partial account state pushed from the legacy app layer.
 *
 * @param nextState - The partial account state to apply.
 */
export function syncAccountStateFromLegacy(nextState: Partial<AccountState>) {
   setAccountState(previous => ({
      ...previous,
      ...nextState,
   }))
}

/**
 * Sets the account height input value.
 *
 * @param value - The raw input value.
 */
export function setAccountHeightInput(value: string) {
   setAccountState(previous => ({
      ...previous,
      heightInput: value,
   }))
}

/**
 * Sets the account target-weight input value.
 *
 * @param value - The raw input value.
 */
export function setAccountTargetWeightInput(value: string) {
   setAccountState(previous => ({
      ...previous,
      targetWeightInput: value,
   }))
}

/**
 * Sets the account monthly run-effort target input value.
 *
 * @param value - The raw input value.
 */
export function setAccountTargetRunEffortInput(value: string) {
   setAccountState(previous => ({
      ...previous,
      targetRunEffortInput: value,
   }))
}

export { accountState }
